// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__1Fz91","burgerLine":"Burger_burgerLine__afJK5"};